import axios from 'axios';
//import React, { Component } from 'react';
import { config } from '../config';
import { session } from '../authentication/session';
//import { connect } from 'react-redux';
//import { Redirect } from 'react-router';

let rest = axios.create({
    baseURL: config.apiUrl,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
    },
    params: {}
});

rest.interceptors.response.use(
    response => response,
    error => {
        if (error.response.status === 401) {
            session.clear();
        }
        return Promise.reject(error);
    });

export const api = rest;

